import "../styles/general.css";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import MaskedInput from "react-text-mask";

import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";
import BlueLoader from "../components/loader/BlueLoader";
import Loader from "../components/loader/Loader";
import MessageModals from "../components/modals/MessageModals";

import { FaCheck } from "react-icons/fa";
import globalContext from "../Contexts/GlobalContext";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import { useNavigate } from "react-router-dom";
import { SERVERMESSAGE } from "../constants/serverMessage";
import AreaSelect from "../components/areaselect/AreaSelect";
import { AREA } from "../constants/areas";
import useRequestHeader from "../hooks/useRequestHeader";

export default function Profile() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  const navigate = useNavigate();
  const [cookies, removeCookies] = useCookies();
  const requestHeader = useRequestHeader();
  // ---->
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [gender, setGender] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(
    cookies?.user ? cookies?.user : ""
  );
  const [telephone, setTelephone] = useState("");
  const [job, setJob] = useState("");
  const [area, setArea] = useState("");
  const [areaCheck, setAreaCheck] = useState("");
  // ---->
  const [nameCheck, setNameCheck] = useState("");
  const [familyCheck, setFamilyCheck] = useState("");
  const [genderCheck, setGenderCheck] = useState("");

  const [telephoneCheck, setTelephoneCheck] = useState("");
  const [jobCheck, setJobCheck] = useState("");

  const [userScore, setUserScore] = useState(0);
  // ---->
  useEffect(() => {
    setIsLoadingGet(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(`${BASE_URL}/user/info/profile`, {}, config)
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setArea(
              AREA.find((item) => item.label === res?.data?.Data?.address)
            );
            setAreaCheck(
              AREA.find((item) => item.label === res?.data?.Data?.address)
            );
            setGender(res?.data?.Data?.gender);
            setGenderCheck(res?.data?.Data?.gender);

            setJob(res?.data?.Data?.job);
            setJobCheck(res?.data?.Data?.job);

            setName(res?.data?.Data?.name);
            setNameCheck(res?.data?.Data?.name);

            setFamily(res?.data?.Data?.lastname);
            setFamilyCheck(res?.data?.Data?.lastname);
            setUserScore(res?.data?.Data?.score);
            setTelephone(
              res?.data?.Data?.telephone.substr(0, 3) +
                "-" +
                res?.data?.Data?.telephone.substr(3, 10)
            );

            setTelephoneCheck(
              res?.data?.Data?.telephone.substr(0, 3) +
                "-" +
                res?.data?.Data?.telephone.substr(3, 10)
            );
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
        setIsLoadingGet(false);
      })
      .catch((err) => {
        setIsLoadingGet(false);
      });
  }, []);

  //// updateProfile section start ////
  const updateProfile = () => {
    if (
      name === nameCheck &&
      family === familyCheck &&
      gender === genderCheck &&
      telephone === telephoneCheck &&
      job === jobCheck &&
      area === areaCheck
    ) {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("اطلاعات تغییر نکرده است");
    } else {
      const updateMe = () => {
        setIsLoading(true);
        const config = {
          headers: requestHeader,
        };
        axios
          .post(
            `${BASE_URL}/user/updateInfo`,
            {
              address: area?.label,
              gender: gender,
              job: job,
              lastname: family,
              name: name,
              telephone: String(telephone).replaceAll("-", ""),
            },
            config
          )
          .then((res) => {
            var responseMode = res?.data?.Mode;
            var responseMessage = res?.data?.Message;
            switch (responseMode) {
              case SERVERMODE.REQUEST_OK: {
                contextData.setIsToastOpen(true);
                contextData.setToastMessage(SERVERMESSAGE.SUCCESS_EDIT_DATA);
                setNameCheck(name);
                setFamilyCheck(family);
                setGenderCheck(gender);
                setTelephoneCheck(telephone);
                setJobCheck(job);
                setAreaCheck(area);
                break;
              }
              default: {
                handleServerMode(
                  responseMode,
                  responseMessage,
                  contextData,
                  cookies,
                  removeCookies,
                  navigate
                );
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            contextData.setIsToastOpen(true);
            contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
          });
      };

      if (name.length >= 3 && family.length >= 3 && gender) {
        let isOk = true;

        if (telephone && String(telephone).replaceAll("-", "")?.length < 11) {
          isOk = false;
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("شماره تلفن ثابت بایستی 11 رقم باشد");
        }
        if (job && job?.length < 3) {
          isOk = false;
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("شغل بایستی بیشتر از 3 کاراکتر باشد ");
        }
        if (area && area?.length < 10) {
          isOk = false;
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("آدرس بایستی بیشتر از 10 کاراکتر باشد");
        }

        if (isOk) {
          updateMe();
        }
      } else {
        if (name.length < 3) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("نام  بایستی بیشتر از 3 کاراکتر باشد ");
        } else if (family.length < 3) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage(
            "نام خانوادگی بایستی بیشتر از 3 کاراکتر باشد "
          );
        } else if (!gender) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("جنسیت نمیتواند خالی باشد");
        }
      }
    }
  };
  //// updateProfile section end ////
  const [isLoadingGet, setIsLoadingGet] = useState(false);
  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className="w-full addCarDetailsBody min-[1024px]:hidden">
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
            time={2000}
          />
        )}
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0 right-0 -z-50"
        />
        <Header relt="relative" />

        <div className="absolute w-full flex flex-col bottom-[24.5vw] top-[17.2vw] items-center justify-start overflow-hidden">
          {/* /// title section start /// */}
          {isLoadingGet && (
            <>
              <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-center z-[600]">
                <Loader width={12} top={0} right={0} />
              </div>
              <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-center z-[550]">
                <svg
                  width="92.45vw"
                  height="33.6vw"
                  viewBox="0 0 393 144"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute backdrop-blur-[2px]"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                    fill="#001D26"
                    fillOpacity="0.701961"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                    stroke="#00FFF2"
                    strokeWidth="0.756725"
                    strokeMiterlimit="2.61313"
                  />
                </svg>
              </div>
            </>
          )}
          <div className={`absolute w-[92.45vw] h-[33.6vw]  top-0 `}>
            <svg
              width="92.45vw"
              height="33.6vw"
              viewBox="0 0 393 144"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                fill="#001D26"
                fillOpacity="0.701961"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                stroke="#00FFF2"
                strokeWidth="0.756725"
                strokeMiterlimit="2.61313"
              />
            </svg>
          </div>

          <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-between">
            <div className="relative w-[60vw] h-full flex items-center justify-center text-color-primary-C font-font_primary_A font-light text-[4vw] pr-[4vw] gap-y-2">
              <div className="w-auto flex flex-col items-center justify-start gap-x-[2vw]">
                <span className="w-full text-left singleLine"> سطح کاربر:</span>
                <span className="w-full text-left singleLine">
                  شماره همراه:
                </span>
              </div>
              <div className="w-full flex flex-col items-center justify-start pr-[2vw]">
                <span className="w-full text-color-primary-B text-right">
                  سطح {"1"}
                </span>
                <MaskedInput
                  value={phoneNumber}
                  className="relative w-full bg-transparent leading-[6vw] outline-none text-color-primary-C focus:text-color-primary-A text-[4vw] font-font_primary_D flex items-center justify-center text-right"
                  dir="ltr"
                  type="text"
                  mask={[
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    "-",
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    "-",
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                  ]}
                  guide={false}
                  disabled
                />
              </div>
            </div>
            <div className="w-[30vw] h-full flex flex-col  items-center justify-center  ">
              <div className="  p-[4px] flex items-center justify-center  ">
                <div className="">
                  <svg
                    width="20vw"
                    height="20vw"
                    viewBox="0 0 151 151"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_50_59)">
                      <path
                        d="M75.1948 40.6892C84.7229 40.6892 93.3499 44.5518 99.5943 50.7962C105.839 57.0406 109.701 65.6676 109.701 75.1957C109.701 84.7237 105.839 93.3508 99.5943 99.5952C93.3499 105.84 84.7229 109.702 75.1948 109.702C65.6668 109.702 57.0406 105.84 50.7953 99.5952C44.5509 93.3508 40.6883 84.7237 40.6883 75.1957C40.6883 65.6676 44.5509 57.0406 50.7953 50.7962C57.0397 44.5518 65.6659 40.6892 75.194 40.6892H75.1948ZM83.8903 114.633L90.0764 131.567L75.194 149.862L60.2862 131.535L66.4638 114.626L66.7326 114.684L67.0014 114.74L67.271 114.795L67.5406 114.848L67.8111 114.899L68.0815 114.948L68.352 114.995L68.6233 115.041L68.8946 115.084L69.1659 115.126L69.4381 115.166L69.7103 115.204L69.9824 115.239L70.2546 115.274L70.5267 115.306L70.7989 115.336L71.0719 115.365L71.3449 115.392L71.6179 115.417L71.8909 115.441L72.1639 115.462L72.4378 115.482L72.7116 115.499L72.9854 115.515L73.2593 115.529L73.5331 115.541L73.807 115.551L74.0808 115.559L74.3547 115.566L74.6285 115.571L74.9024 115.575L75.1762 115.576L75.4501 115.575L75.7239 115.572L75.9978 115.568L76.2716 115.562L76.5455 115.554L76.8193 115.544L77.0932 115.532L77.367 115.519L77.6409 115.504L77.9147 115.486L78.1886 115.467L78.4616 115.445L78.7346 115.423L79.0076 115.398L79.2806 115.372L79.5527 115.343L79.8257 115.313L80.0979 115.281L80.37 115.247L80.6422 115.211L80.9144 115.173L81.1857 115.133L81.4578 115.092L81.7291 115.049L82.0004 115.004L82.2718 114.958L82.5422 114.909L82.8127 114.858L83.0823 114.806L83.3519 114.751L83.6207 114.696L83.8895 114.638L83.8903 114.633ZM45.8576 125.579L22.398 127.993L24.8161 104.492L41.1405 96.9032C44.3016 101.852 48.5116 106.066 53.4569 109.231L45.8576 125.579ZM18.8244 90.0773L0.528198 75.1957L18.8566 60.2879L35.7658 66.4655C34.5022 72.1994 34.4997 78.1564 35.7582 83.892L18.8244 90.0781V90.0773ZM24.8119 45.8576L22.398 22.398L45.899 24.8161L53.4873 41.1405C48.5386 44.3016 44.3253 48.5116 41.1599 53.4569L24.8119 45.8576ZM60.3132 18.8244L75.1948 0.528198L90.1026 18.8566L83.9258 35.7658C78.1919 34.5022 72.2349 34.4997 66.4993 35.7582L60.3132 18.8244ZM104.532 24.8119L127.993 22.398L125.574 45.899L109.25 53.4873C106.089 48.5386 101.879 44.3253 96.9336 41.1599L104.533 24.8119H104.532ZM131.566 60.3132L149.861 75.1948L131.534 90.1026L114.625 83.9258C115.888 78.1919 115.891 72.2349 114.631 66.4993L131.565 60.3132H131.566ZM125.578 104.532L127.993 127.993L104.491 125.574L96.9023 109.25C101.851 106.089 106.065 101.879 109.23 96.9336L125.578 104.533V104.532ZM95.0691 55.3206C89.9835 50.235 82.9564 47.0891 75.1948 47.0891C67.4333 47.0891 60.4062 50.235 55.3206 55.3206C50.235 60.4062 47.0891 67.4333 47.0891 75.1948C47.0891 82.9564 50.235 89.9835 55.3206 95.0691C60.4062 100.155 67.4333 103.301 75.1948 103.301C82.9564 103.301 89.9835 100.155 95.0691 95.0691C100.155 89.9835 103.301 82.9564 103.301 75.1948C103.301 67.4333 100.155 60.4062 95.0691 55.3206Z"
                        stroke="#FEC42B"
                        strokeWidth="1.5"
                        strokeMiterlimit="2.61313"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_50_59">
                        <rect width="150.39" height="150.39" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className="w-auto min-w-[15vw] py-[0.25vw] px-[1vw] flex items-end justify-center gap-x-[2vw] text-[#153038] font-font_primary_D font-medium text-[3vw] mt-[1vw] bg-color-primary-B rounded-[0.45vw]">
                <span>Lux</span>
                <span className="font-semibold">{userScore}</span>
              </div>
            </div>
          </div>
          {/* /// title section end /// */}

          {isLoadingGet && (
            <div className="absolute  w-[92.68867924528302vw]   backdrop-blur-[2px] border-[1px] border-color-primary-D  rounded-[1.886792452830189vw] bottom-[0vw] top-[37.5vw] z-[1000]">
              <div className="w-full h-full backdrop-blur-sm z-[550] ">
                <Loader width={12} top={0} right={0} />
              </div>
            </div>
          )}
          <div className="absolute w-[92.68867924528302vw] bg-[#04181F] opacity-80 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] bottom-[0vw] top-[37.5vw]"></div>
          <div className="relative flex w-full justify-center mt-0 px-[6.5vw] "></div>
          <div className="flex flex-col items-center justify-start w-[92.68867924528302vw] absolute top-[42vw] bottom-0 pb-[2vw] overflow-scroll z-[500]">
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw]">
              <span
                className={`absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]`}
              >
                نام
              </span>
              <MaskedInput
                mask={[
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                ]}
                guide={false}
                type="text"
                dir="ltr"
                value={name}
                className={`relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] border-color-primary-D leading-[6vw] outline-none text-color-primary-A focus:text-color-primary-A text-[4.5vw] focus:text-[4.5vw] font-font_primary_A focus:font-font_primary_A`}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span className="absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                نام خانوادگی
              </span>
              <MaskedInput
                mask={[
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                ]}
                guide={false}
                type="text"
                dir="ltr"
                value={family}
                className="relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] border-color-primary-D leading-[6vw] outline-none text-color-primary-A focus:text-color-primary-A text-[4.5vw] focus:text-[4.5vw] font-font_primary_A focus:font-font_primary_A"
                onChange={(e) => {
                  setFamily(e.target.value);
                }}
              />
            </div>
            <div className="relative w-[82.95047169811321vw] h-[10vw] min-h-[10vw] mb-[2vw] flex items-center justify-between pl-[2vw]">
              <span className="relative text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                جنسیت
              </span>
              <div
                className=" flex items-center justify-between gap-x-[2vw]"
                onClick={() => {
                  setGender("male");
                }}
              >
                <span className="text-[#fff] font-font_primary_A font-extralight text-[4vw]">
                  مرد
                </span>
                <div className="relative w-[3.773584905660377vw] h-[3.773584905660377vw] border-color-primary-D border-[1px]">
                  {gender === "male" && (
                    <FaCheck className="absolute top-0 left-0 w-[3.773584905660377vw] h-[3.773584905660377vw] text-[#fff]" />
                  )}
                </div>
              </div>
              <div
                className="flex items-center justify-between gap-x-[2vw] "
                onClick={() => {
                  setGender("female");
                }}
              >
                <span className="text-[#fff] font-font_primary_A font-extralight text-[4vw]">
                  زن
                </span>
                <div className="relative w-[3.773584905660377vw] h-[3.773584905660377vw]  border-color-primary-D border-[1px]">
                  {gender === "female" && (
                    <FaCheck className="absolute top-0 left-0 w-[3.773584905660377vw] h-[3.773584905660377vw] text-[#fff]" />
                  )}
                </div>
              </div>
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span
                className={`absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]`}
              >
                شماره تلفن ثابت
              </span>
              <MaskedInput
                mask={[
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  "-",
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                  /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                ]}
                guide={false}
                type="tel"
                dir="ltr"
                value={telephone}
                maxLength={17}
                className={`relative w-[82.95047169811321vw]  border-b-[1px] border-color-primary-D  text-left bg-transparent text-color-primary-A focus:text-color-primary-A  leading-[6vw] outline-none  text-[4.5vw] focus:text-[4.5vw] font-font_primary_A focus:font-font_primary_A`}
                onChange={(e) => {
                  setTelephone(e.target.value);
                }}
              />
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span
                className={`absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]`}
              >
                شغل
              </span>
              <MaskedInput
                mask={[
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                  /^[\u0600-\u06FF_ ]+$/,
                ]}
                guide={false}
                type="text"
                dir="ltr"
                value={job}
                maxLength={17}
                className={`relative w-[82.95047169811321vw]  border-b-[1px] border-color-primary-D  text-left bg-transparent  text-color-primary-A focus:text-color-primary-A  leading-[6vw] outline-none  text-[4.5vw] focus:text-[4.5vw] font-font_primary_A focus:font-font_primary_A`}
                onChange={(e) => {
                  setJob(e.target.value);
                }}
              />
            </div>
            <div className="relative flex items-start justify-end  w-[82.95047169811321vw]  h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw] ">
              <span
                className={`absolute bottom-[5vw] right-0 text-color-primary-D font-font_primary_A font-extralight text-[4vw]`}
              >
                شهر
              </span>
              <div
                dir="ltr"
                className="relative w-[70vw] float-left   bg-transparent  text-color-primary-A focus:text-color-primary-A  leading-[6vw] outline-none  text-[4.5vw] focus:text-[4.5vw] font-font_primary_A focus:font-font_primary_A"
              >
                <AreaSelect area={area} setArea={setArea} />
              </div>
              <span className="absolute bottom-[-2vw] right-0 font-font_primary_A text-color-primary-C1 text-[2.5vw] ">
                به منظور ارائه خدمات بهتر محدوده شهری خود راانتخاب نمایید
              </span>
            </div>
          </div>
        </div>

        {/* /// footer section /// */}
        <div className="absolute bottom-[3.681603773584906vw] w-full flex items-center justify-center mt-[1.937046004842615vh]">
          {isLoading ? (
            <>
              <div className="w-[92.68867924528302vw] h-[16.9811320754717vw] bg-[#001D26] opacity-70 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[7.547169811320755vw]">
                <BlueLoader position="" width={14} />
              </div>
            </>
          ) : (
            <>
              <button
                className="w-[92.68867924528302vw] h-[16.9811320754717vw] font-bold bg-[#001D26] opacity-70 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[7vw]"
                onClick={updateProfile}
              >
                ویرایش
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
